import React, { useState, useEffect } from "react";
import { Tab, Tabs, Container, Row, Col, Card } from "react-bootstrap";

import FakeDataUpload from '../Components/Finance/FakeDataUpload';
import Header_Finance from '../Components/Finance/Header_Finance';
import ReportbyDateFilterDummy from '../Components/Finance/ReportbyDateFilterDummy';

import UploadFileForReversal from "../Components/CustomerServices/UploadFileForReversal";
import CustomerService_Header from "../Components/CustomerServices/CustomerService_Header";
const Upload = () => {
    const [userData, setUserData] = useState(null);

    // Load user data from sessionStorage on component mount
    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem("user"));
        if (user) {
            setUserData(user);
        } else {
            console.log("No user found in sessionStorage");
        }
    }, []);

    // Render content based on user role
    if (userData && userData.userRole === "Finance") {
        return (
            <div className="container-fluid">

                <Header_Finance />

                <Container className="mt-4">
                    <Tabs defaultActiveKey="reportByDateFilter" id="report-tabs" className="mb-3">
                        {/* Tab for Date Filter Report */}
                        <Tab eventKey="reportByDateFilter" title="Report by Date Range">
                            <Row className="mt-3">
                                <Col>
                                    <Card className="shadow-lg">
                                        <Card.Header>
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <h5>Generate Dummy Report by Date Range</h5>
                                                </div>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <ReportbyDateFilterDummy /> {/* Remove search query prop */}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Tab>

                        {/* Tab for MSISDN Report */}
                        <Tab eventKey="uploadfile" title="Upload File">
                            <Row className="mt-1">
                                <Col>
                                    <Card className="shadow-lg">
                                        <Card.Header>
                                            <div className="row">
                                                <div className="col-md-8">
                                                <h5>Please upload a file and select the status </h5>
                                                </div>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <FakeDataUpload /> {/* Remove search query prop */}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Tab>
                    </Tabs>
                </Container>
                {/* <Row className="mt-3">
                    <Col>
                        <Card className="shadow-lg">
                            <Card.Header>
                            </Card.Header>
                            <Card.Body>
                                <FakeDataUpload /> 
                            </Card.Body>
                        </Card>
                    </Col>
                </Row> */}
            </div>
        );
    } 
    else {
        return <div className="text-center mt-5">You do not have permission to view this page.</div>;
    }
};

export default Upload;
